import { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { initializeAuthAsync } from "./auth/authSlice";
import Navigation from "./navigation";
import type { RootState, AppDispatch } from "./redux/store";

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const { initialized, isAuthenticated, loading, permissionCount } = useSelector(
    (state: RootState) => ({
      initialized: state.auth?.initialized ?? false,
      isAuthenticated: state.auth?.isAuthenticated ?? false,
      loading: state.auth?.loading ?? false,
      permissionCount: Array.isArray(state.userPermissions?.permissionCodes)
        ? state.userPermissions.permissionCodes.length
        : 0,
    }),
    shallowEqual,
  );

  useEffect(() => {
    dispatch(initializeAuthAsync());
  }, [dispatch]);

  const ready = initialized && (!isAuthenticated || !loading || permissionCount > 0);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
        <div className="text-slate-700 dark:text-slate-200 text-sm">
          {loading ? "Loading…" : "Preparing your workspace…"}
        </div>
      </div>
    );
  }

  return <Navigation />;
}

export default App;
